import { DatePicker } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { DatePickerIcon, DatePickerNext, DatePickerPreview } from "themes/Icon";
import "./date_range_picker_comp.scss"; // Ensure you have the corresponding CSS

const { RangePicker } = DatePicker;

function DateRangePickerComp({
  className,
  suffixIcon,
  onChange,
  format = "DD-MM-YYYY",
  allowClear = true,
  placeholder = ["Start date", "End date"],
  disabledDate,
  value,
  setValue,
}) {
  const [dates, setDates] = useState([null, null]);

  useEffect(() => {
    if (value) {
      setDates([dayjs(value[0], format), dayjs(value[1], format)]);
    } else {
      setDates(null);
    }
  }, [value]);

  const handleRangeChange = (dates, dateStrings) => {
    setDates(dates);
    if (onChange && dates) {
      onChange(dateStrings);
    } else {
      onChange(null);
    }
  };

  return (
    <RangePicker
      value={dates}
      suffixIcon={suffixIcon || <DatePickerIcon />}
      placeholder={placeholder}
      className={`range-picker ${className}`}
      format={format}
      allowClear={allowClear}
      onChange={handleRangeChange}
      nextIcon={<DatePickerNext />}
      onClear={() => {
        setDates(null); // Resetting dates on clear
        setValue([]);
        if (onChange) {
          onChange(null); // Inform the parent component
        }
      }}
      prevIcon={<DatePickerPreview />}
      popupClassName="range-picker-popup"
      showNow={false}
      disabledDate={disabledDate}
    />
  );
}

export default DateRangePickerComp;
